import { render, staticRenderFns } from "./BaseIconTypeahead.vue?vue&type=template&id=0b42727e&scoped=true&"
import script from "./BaseIconTypeahead.vue?vue&type=script&lang=js&"
export * from "./BaseIconTypeahead.vue?vue&type=script&lang=js&"
import style0 from "./BaseIconTypeahead.vue?vue&type=style&index=0&id=0b42727e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b42727e",
  null
  
)

export default component.exports